import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async createBrand(
        { commit, dispatch },
        { active, content, images, keywords, name, slug, summary }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/brands", {
                name,
                content,
                summary,
                slug,
                keywords,
                images,
                active
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async listBrandsPaginated(
        { commit, dispatch },
        { active, complete, itemsByPage, keyword, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/brands", {
                params: { active, complete, itemsByPage, keyword, page }
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async listAllBrands({ commit, dispatch }, { active, keyword = "" }) {
        try {
            const { data } = await Http.instance.get("/bo/brands/all", {
                params: { active, keyword }
            });
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async getBrandBySlug({ commit, dispatch }, { slug }) {
        try {
            const { data } = await Http.instance.get(`/bo/brands/${slug}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async updateBrand(
        { commit, dispatch },
        { active, content, images, keywords, name, slug, summary }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/brands/${slug}`, {
                name,
                content,
                keywords,
                summary,
                images,
                active
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async deleteBrand({ commit, dispatch }, { slug }) {
        try {
            await Http.instance.delete(`/bo/brands/${slug}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async listHighlightBrands({ commit, dispatch }, { lineSlug }) {
        try {
            const { data } = await Http.instance.get("/bo/brands/highlight", {
                params: { lineSlug }
            });
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async updateHighlightBrands(
        { commit, dispatch },
        { brandsSlugs, lineSlug }
    ) {
        try {
            const { data } = await Http.instance.put("/bo/brands/highlight/", {
                lineSlug,
                brandsSlugs
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    },

    async updateBrandsWeights({ commit, dispatch }, { brands }) {
        try {
            await Http.instance.put("/bo/brands/massive/weights", { brands });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_BRANDS", parseError);
            throw parseError;
        }
    }
};

export default actions;
